import { BasicInput, PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { UNCPessoa } from 'common/type';
import { FieldProps, FormikProps, getIn } from 'formik';
import { FC } from 'react';

import {
  PessoaMatriculaSearch,
  PessoaMatriculaSearchProps
} from './PessoaMatriculaSearch';

type FormikPessoaMatriculaSearchProps = Partial<PessoaMatriculaSearchProps> & {
  name: string;
  size?: number;
  fast?: boolean;
  onSearch: (search: string) => AxiosPromise<PagedResponse<UNCPessoa>>;
  onItemSelected?: (
    form: FormikProps<any>,
    name: string,
    value: UNCPessoa
  ) => void;
};

export const FormikPessoaMatriculaSearch: FC<
  FormikPessoaMatriculaSearchProps
> = ({ name, size = 4, fast = false, onSelect, onItemSelected, ...props }) => {
  const renderPessoaMatriculaSearch = ({
    field: { onChange, ...fieldProps },
    form
  }: FieldProps) => {
    return (
      <PessoaMatriculaSearch
        {...props}
        {...fieldProps}
        name={name}
        onSelect={(name, value) => {
          if (onSelect) {
            onSelect(name, value);
          } else {
            form.setFieldValue(name, value);
            form.setFieldTouched(name, true);

            if (onItemSelected) {
              onItemSelected(form, name, value);
            }
          }
        }}
        error={
          !!(
            getIn(form.errors, name) &&
            (getIn(form.touched, name) || form.submitCount > 0)
          )
        }
      />
    );
  };

  return (
    <BasicInput
      noLabel
      {...props}
      name={name}
      fast={fast}
      size={size}
      render={renderPessoaMatriculaSearch}
    />
  );
};
